import { Collection } from 'modules/core/lib/mobx-rest'

import Leave from 'modules/shift_management/store/api/models/Leave'

class Leaves extends Collection<Leave> {
  get cacheKey(): string {
    return 'leaves'
  }
  model() {
    return Leave
  }
}

const singleton: Leaves = new Leaves()

export default singleton
